import { mutations as types } from "./types";
import { FETCH } from "@/utils/list.js";

let comparer = (obj, item) => {
  return obj.id === item.id;
};

let transformPage = page => {
  page.title = page.pageTitle;
  return page;
};

let getItemsName = (template, items) => {
  var assignsList = [];
  // Mark 1
  assignsList = items
    .filter(el => {
      if (el) {
        let suffix = "";
        if (el.template_suffix) {
          suffix = el.template_suffix;
        }
        let templateID = suffix.split("-");
        if (templateID && templateID.length == 3) {
          templateID = templateID[1];
        } else {
          templateID = null;
        }
        // Nếu là default thì là ko có template_suffix hoặc assign template_suffix.includes(template.id)
        // Nếu không phải default thì chỉ lấy ra assign template_suffix.includes(template.id)
        if (template.published) {
          if (!suffix || templateID == template.id) {
            return el;
          }
        } else {
          if (templateID == template.id) {
            return el;
          }
        }
      }
      // }
    })
    .map(item => item.title);

  return assignsList.join("\n");
};

const mutations = {
  [types.PAGE_FETCH_PAGES]: (state, { pages, type }) => {
    FETCH(state.pages[type].list, pages, comparer, null);
  },
  [types.PAGE_FETCH_ASSIGNMENTS]: (state, { pages, type }) => {
    FETCH(state.assignments[type].list, pages, comparer, null);
  },
  [types.PAGE_FETCH_NEWEST_ITEMS]: (state, { pages, type }) => {
    FETCH(state.assignments.newestItems[type].list, pages, comparer, null);
  },
  [types.PAGE_FETCH_ALL_ITEMS]: (state, { items, type, total }) => {
    FETCH(state.assignments[type].list, items, comparer, null);
    state.pages[type].list.forEach(page => {
      page.itemsName = getItemsName(page, state.assignments[type].list);
    });
    if (total && total != undefined) {
      state.assignments[type].total = total;
    }
  },
  [types.PAGE_ASSIGN_TEMPLATE]: (state, { assignId, templateId, type }) => {
    let stringSuffix = "";
    if (templateId == "inherit") {
      stringSuffix = "";
    } else {
      stringSuffix = "gem-" + templateId + "-template";
    }
    let assignIds = assignId.split(",");
    let oldTemplateID = -1;
    if (assignIds && assignIds.length) {
      let assignItem = state.assignments[type].list.find(e => e.id == assignIds);
      if (assignItem && assignItem.template_suffix && assignItem.template_suffix.includes("gem-")) {
        oldTemplateID = assignItem.template_suffix.split("-")[1];
      }
    }
    assignIds.forEach(aID => {
      // Find item index
      let index = state.assignments[type].list.findIndex(e => e.id == aID);
      if (index >= 0) {
        // Unassign product/collection
        if (templateId == 0) {
          let item = state.assignments[type].list[index];
          if(item?.template_suffix) {
            item.template_suffix = ""
          }
          return;
        }
        state.assignments[type].list[index].template_suffix = stringSuffix;
        let d = new Date();
        state.assignments[type].list[index].updated_at = d.toISOString();
        state.assignments[type].list[index].isNew = true;
        // let x = JSON.parse(JSON.stringify(state.assignments[type].list[index]));
        // x.template_suffix = stringSuffix;
        // state.assignments[type].list.splice(index, 1, x);
      }
    });
    let oldTemplateFound = state.pages[type].list.find(e => e.id == oldTemplateID);
    if (oldTemplateFound) {
      oldTemplateFound.itemsName = getItemsName(oldTemplateFound, state.assignments[type].list);
    }
    let templateFound = state.pages[type].list.find(e => e.id == templateId);
    if (templateFound) {
      templateFound.itemsName = getItemsName(templateFound, state.assignments[type].list);
    }
  },
  [types.PAGE_NEW_PAGE]: (state, { page, type }) => {
    page.title = page.pageTitle;
    page.layout = page.pageLayout;
    page.handle = page.pageHandle;
    page.type = page.pageType;
    page.updated_at = Date.now();
    FETCH(state.pages[type].list, [page], comparer, transformPage);
  },
  [types.PAGE_UPDATE_PAGES_FILTER]: (state, { type, filter }) => {
    state.pages[type].filter = filter;
    let reverse = false;
    if (filter.includes("DESC")) {
      reverse = true;
    }
    state.pages[type].reverse = reverse;
  },
  [types.PAGE_UPDATE_PAGES_PAGINATION]: (state, { type, pagination }) => {
    state.pages[type].pagination.page = pagination.page;
  },
  [types.PAGE_UPDATE_ASSIGNMENTS_PAGINATION]: (state, { type, pagination }) => {
    state.assignments[type].pagination.page = pagination.page;
  },
  [types.PAGE_UPDATE_PAGES_STATUS]: (state, { type, loading = false, success = false, error = false }) => {
    state.pages[type].status.loading = loading;
    state.pages[type].status.success = success;
    state.pages[type].status.error = error;
  },
  [types.PAGE_UPDATE_RECENT_STATUS]: (state, { loading = false, success = false, error = false }) => {
    state.pages.recentPage.status.loading = loading;
    state.pages.recentPage.status.success = success;
    state.pages.recentPage.status.error = error;
  },
  [types.PAGE_UPDATE_PAGES_STATUS_LIST]: (state, { type, loading = false, success = false, error = false }) => {
    state.pages[type].statusList.loading = loading;
    state.pages[type].statusList.success = success;
    state.pages[type].statusList.error = error;
  },
  [types.PAGE_UPDATE_TEMPLATES_STATUS_LIST]: (state, { loading = false, success = false, error = false }) => {
    state.templates.statusList.loading = loading;
    state.templates.statusList.success = success;
    state.templates.statusList.error = error;
  },
  [types.PAGE_UPDATE_ASSIGNMENTS_STATUS_LIST]: (state, { type, loading = false, success = false, error = false }) => {
    state.assignments[type].statusList.loading = loading;
    state.assignments[type].statusList.success = success;
    state.assignments[type].statusList.error = error;
  },
  [types.PAGE_UPDATE_TEMPLATES_STATUS]: (state, { loading = false, success = false, error = false }) => {
    state.templates.status.loading = loading;
    state.templates.status.success = success;
    state.templates.status.error = error;
  },
  [types.PAGE_UPDATE_ASSIGNMENTS_STATUS]: (state, { type, loading = false, success = false, error = false }) => {
    state.assignments[type].status.loading = loading;
    state.assignments[type].status.success = success;
    state.assignments[type].status.error = error;
  },
  [types.PAGE_DELETE_PAGE]: (state, { page, type }) => {
    let indexFound = state.pages[type].list.findIndex(e => {
      return e.id == page.id;
    });

    if (indexFound >= 0) {
      state.pages[type].list.splice(indexFound, 1);
    }
  },
  [types.PAGE_DELETE_IN_SEARCH]: (state,{ page }) => {
    //delete in list page
    let indexFound = null
    if (state.search.pages){
      indexFound = state.search.pages.findIndex(e => {
        return e.id == page.id;
      })
      if (indexFound >= 0) {
        state.search.pages.splice(indexFound, 1);
      }
    }
  },
  [types.PAGE_DELETE_RECENT_PAGE]: (state, { page }) => {
    let indexFound = state.pages.recentPage.list.findIndex(e => {
      return e.id == page.id;
    });

    if (indexFound >= 0) {
      state.pages.recentPage.list.splice(indexFound, 1);
    }
  },
  // FIXME: check update before send request
  [types.PAGE_UPDATE_PAGE_INFO]: (state, { oldPage, newPage, type }) => {
    let indexFound = state.pages[type].list.findIndex(e => {
      return e.id == oldPage.id;
    });
    if (indexFound >= 0) {
      const fields = ["pageTitle", "pageLayout", "pageHandle", "pageType"];
      state.pages[type].list[indexFound].updated_at = Date.now();
      let changed = 0;
      fields.forEach(field => {
        if (newPage[field] != undefined) {
          let fieldName = field.toLocaleLowerCase().substr(4);
          if (state.pages[type].list[indexFound][fieldName] != newPage[field]) {
            changed++;
          }
          state.pages[type].list[indexFound][fieldName] = newPage[field];
        }
      });
      if (newPage.__justUpdated && changed) {
        state.pages[type].list[indexFound].__justUpdated = newPage.__justUpdated;
      }
    }
  },
  [types.PAGE_UPDATE_PAGE_INFO_RECENT_PAGE]: (state, { oldPage, newPage }) => {
    let indexFound = state.pages.recentPage.list.findIndex(e => {
      return e.id == oldPage.id;
    });
    if (indexFound >= 0) {
      state.pages.recentPage.list[indexFound].title = newPage.pageTitle;
      state.pages.recentPage.list[indexFound].layout = newPage.pageLayout;
      state.pages.recentPage.list[indexFound].handle = newPage.pageHandle;
      state.pages.recentPage.list[indexFound].type = newPage.pageType;
      state.pages.recentPage.list[indexFound].updated_at = Date.now();
    }
  },
  [types.PAGE_CLONE_PAGE]: (state, { newPage, type, groupID }) => {
    newPage.title = newPage.pageTitle;
    newPage.layout = newPage.pageLayout;
    newPage.handle = newPage.pageHandle;
    newPage.type = newPage.pageType;
    newPage.updated_at = Date.now();
    newPage.page_group_id = groupID;
    newPage.author = "Shopify API";
    if (["productpages", "collectionpages"].includes(type)) {
      newPage.published = false;
    }

    state.pages[type].list.push(newPage);
  },
  [types.PAGE_CLONE_RECENT_PAGE]: (state, { newPage }) => {
    newPage.title = newPage.pageTitle;
    newPage.layout = newPage.pageLayout;
    newPage.handle = newPage.pageHandle;
    newPage.type = newPage.pageType;
    newPage.updated_at = Date.now();

    state.pages.recentPage.list.unshift(newPage);
  },
  [types.PAGE_CLONE_RECENT_V2_PAGE]: (state, { newPage }) => {
    newPage.template_id = newPage.pageId;
    newPage.title = newPage.pageTitle;
    newPage.layout = newPage.pageLayout;
    newPage.handle = newPage.pageHandle;
    newPage.type = newPage.pageType;
    newPage.updated_at = Date.now();

    state.pages.recentPage.list.unshift(newPage);
  },
  [types.PAGE_MAKE_DEFAULT]: (state, { page, type }) => {
    let previousPageDefaultIndex = state.pages[type].list.findIndex(e => {
      return e.published;
    });
    if (previousPageDefaultIndex >= 0) {
      state.pages[type].list[previousPageDefaultIndex].published = false;
    }

    let newDefaultIndex = state.pages[type].list.findIndex(e => {
      return e.id == page.id;
    });
    if (newDefaultIndex >= 0) {
      state.pages[type].list[newDefaultIndex].published = true;
      state.pages[type].list[newDefaultIndex].is_published = true;
      state.pages[type].list[newDefaultIndex].lastAction = "pagePublish";
      state.pages[type].list[newDefaultIndex].updated_at = Date.now();
    }
  },
  [types.PAGE_FETCH_TEMPLATES]: (state, { templates, tags }) => {
    state.templates.list = templates;
    state.templates.fetched = true;
    state.templates.tags = tags;
  },

  [types.UPDATE_PUBLISHED_COUNT]: (state, payload) => {
    state.publishedPageCount = state.publishedPageCount + payload.count;
    state.publishedPage[payload.type] = state.publishedPage[payload.type] +payload.count
  },

  [types.PAGE_UPDATE_QUERY](state, { query, type }) {
    state.pages[type].query = query;
  },
  [types.PAGE_UPDATE_GROUP_SELECTED](state, { group_id, type }) {
    state.pages[type].group_query = group_id;
  },
  [types.PAGE_UPDATE_SEARCH_QUERY](state, query) {
    state.search.query = query;
  },
  [types.PAGE_UPDATE_SEARCH_LOADING](state, loading) {
    state.search.loading = loading;
  },
  [types.PAGE_APPEND_SEARCH_DATA](state, { pages, templates, faqs }) {
    if (pages && pages.length) FETCH(state.search.pages, pages, comparer);
    if (templates && templates.length) FETCH(state.search.templates, templates, comparer);
    if (faqs && faqs.length) FETCH(state.search.faqs, faqs, comparer);
  },
  [types.PAGE_SET_GROUP_ID](state, data) {
    data.data.forEach(el => {
      let indexFound = state.pages[data.pageType].list.findIndex(e => {
        return e.id == el.id;
      });
      if (indexFound >= 0) {
        if (el.value) {
          state.pages[data.pageType].list[indexFound].page_group_id = data.groupId;
        } else {
          state.pages[data.pageType].list[indexFound].page_group_id = null;
        }
      }
    });
  },
  [types.SEARCH_ITEMS](state, { data, type }) {
    FETCH(state.assignments[type].list, data, comparer, null);
  },
  [types.PAGE_INCREASE_VIEW_TEMPLATE](state, { id, inc = 1 }) {
    let comparer = item => item.id == id;
    let inSearch = state.search.templates.find(comparer);
    let inTemplates = state.search.templates.find(comparer);
    if (inSearch) {
      inSearch.view += inc;
    }
    if (inTemplates) {
      inTemplates.view += inc;
    }
  },
  [types.UPDATE_GROUP_ID](state, { type, pageId, groupId }) {
    let found = state.pages[type].list.find(e => e.id == pageId);
    if (found) {
      found.page_group_id = groupId;
    }
  },
  [types.PAGE_SWITCH_PUBLISH](state, { type, id }) {
    let found = state.pages[type].list.find(e => e.id == id);
    if (found) {
      if (!found.gp_unlink || found.gp_unlink == undefined ) {
        found.gp_unlink = true
        found.updated_at = Date.now()
      } else {
        found.gp_unlink = false
        found.updated_at = Date.now()
      }
    }
  },
  [types.DUPLICATE_TO](state, {page, type}) {
    page.title = page.pageTitle;
    page.layout = page.pageLayout;
    page.handle = page.pageHandle;
    page.type = page.pageType;
    page.updated_at = Date.now();
    page.author = "Shopify API";
    page.isGpTemplate = true;
    FETCH(state.pages[type].list, [page], comparer, transformPage);
  },
  [types.PAGE_MUTATE_JUST_UPDATED](state, { id, type, value}) {
    let index = state.pages[type].list.findIndex(x => x.id == id);
    if (index > -1) {
      let obj = JSON.parse(JSON.stringify(state.pages[type].list[index]));
      obj.__justUpdated = value;
      state.pages[type].list.splice(index, 1, obj);
    }
  },
  [types.MODIFY_LAYOUT](state, { id, type, layout }) {
    let found = state.pages[type].list.find(e => e.id == id);
    if(found) {
      found.articleLayout = layout;
      found.updated_at = Date.now();
      found.__justUpdated = true;
    }
  },
  OPEN_AB_TESTING_BLOCK_MODAL(state, campaignID) {
    state.abTestingBlockModal = campaignID;
  },
  [types.PAGE_UPDATE_ASSIGN_ALL_PRODUCT]: (state, isAssignAll) => {
    state.assignments.productpages.isAssignAll = isAssignAll;
  },
  [types.PAGE_UPDATE_ASSIGN_ALL_COLLECTION]: (state, isAssignAll) => {
    state.assignments.collectionpages.isAssignAll = isAssignAll;
  },
  [types.SET_FRAME_LOADING]: (state, {isLoading, typeLoading = "rendering_loading"}) => { // create_new_page || rendering_loading
    state.loadingFrame = isLoading;
    state.loadingFrameType = typeLoading;
  },
  [types.SET_DEFAULT_PAGE_NAME]: (state, name) => {
    state.defaultPageName = name;
  },
  [types.RESET_FETCHED_PAGE]: (state, pageType) => {
    state.pages[pageType].fetched = false;
  },
};

export default mutations;
